import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "navbar-brand navbar-brand-autodark pe-3" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Company Ltd")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    id: "navbar-menu",
    class: "navbar-collapse collapse"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-fill align-items-stretch" }, [
      /*#__PURE__*/_createElementVNode("ul", { class: "navbar-nav flex-grow-1" }, [
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
          /*#__PURE__*/_createElementVNode("a", {
            class: "nav-link",
            href: "#"
          }, [
            /*#__PURE__*/_createElementVNode("span", { class: "nav-link-icon" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "icon",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }),
                /*#__PURE__*/_createElementVNode("polyline", { points: "5 12 3 12 12 3 21 12 19 12" }),
                /*#__PURE__*/_createElementVNode("path", { d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" }),
                /*#__PURE__*/_createElementVNode("path", { d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("span", { class: "nav-link-title" }, " Home ")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
          /*#__PURE__*/_createElementVNode("a", {
            class: "nav-link",
            href: "#"
          }, [
            /*#__PURE__*/_createElementVNode("span", { class: "nav-link-icon" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "icon",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }),
                /*#__PURE__*/_createElementVNode("circle", {
                  cx: "9",
                  cy: "7",
                  r: "4"
                }),
                /*#__PURE__*/_createElementVNode("path", { d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" }),
                /*#__PURE__*/_createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" }),
                /*#__PURE__*/_createElementVNode("path", { d: "M21 21v-2a4 4 0 0 0 -3 -3.85" })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("span", { class: "nav-link-title" }, " Customers ")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item dropdown" }, [
          /*#__PURE__*/_createElementVNode("a", {
            class: "nav-link",
            href: "#"
          }, [
            /*#__PURE__*/_createElementVNode("span", { class: "nav-link-icon" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "icon",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }),
                /*#__PURE__*/_createElementVNode("line", {
                  x1: "18",
                  y1: "6",
                  x2: "18",
                  y2: "6.01"
                }),
                /*#__PURE__*/_createElementVNode("path", { d: "M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5" }),
                /*#__PURE__*/_createElementVNode("polyline", { points: "10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15" }),
                /*#__PURE__*/_createElementVNode("line", {
                  x1: "9",
                  y1: "4",
                  x2: "9",
                  y2: "17"
                }),
                /*#__PURE__*/_createElementVNode("line", {
                  x1: "15",
                  y1: "15",
                  x2: "15",
                  y2: "20"
                })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("span", { class: "nav-link-title" }, " Locations ")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item dropdown" }, [
          /*#__PURE__*/_createElementVNode("a", {
            class: "nav-link",
            href: "#"
          }, [
            /*#__PURE__*/_createElementVNode("span", { class: "nav-link-icon" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "icon",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }),
                /*#__PURE__*/_createElementVNode("path", { d: "M9 4h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" }),
                /*#__PURE__*/_createElementVNode("path", { d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2" })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("span", { class: "nav-link-title" }, " Documents ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "m-2" }, [
        /*#__PURE__*/_createElementVNode("form", {
          action: ".",
          method: "get"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "input-icon" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "input-icon-addon" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "icon",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                stroke: "currentColor",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  stroke: "none",
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }),
                /*#__PURE__*/_createElementVNode("circle", {
                  cx: "10",
                  cy: "10",
                  r: "7"
                }),
                /*#__PURE__*/_createElementVNode("line", {
                  x1: "21",
                  y1: "21",
                  x2: "15",
                  y2: "15"
                })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search…",
              "aria-label": "Search in website"
            })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "navbar-nav d-flex align-items-center" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "avatar avatar-sm text-white bg-blue" }, "JD"),
        /*#__PURE__*/_createElementVNode("div", { class: "d-block ps-2" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "text-white" }, "John Doe"),
          /*#__PURE__*/_createElementVNode("div", { class: "small text-muted" }, "Admin User")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, _hoisted_3))
}